import { render, staticRenderFns } from "./SdlMetrics.vue?vue&type=template&id=56232e58&scoped=true&"
import script from "./SdlMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./SdlMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SdlMetrics.vue?vue&type=style&index=0&id=56232e58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56232e58",
  null
  
)

export default component.exports